import { EXPERTISE_STATUSES } from './constants';

export const EXPERTISE_STATUSES_DATA = {
  [EXPERTISE_STATUSES.WITHOUT_MY_EXPERTISE]: {
    id: EXPERTISE_STATUSES.WITHOUT_MY_EXPERTISE,
    text: 'Без моей оценки',
    icon: null,
    attrs: {},
    searchKeys: {
      'search[with_my_expertise]': 0,
    },
  },
  [EXPERTISE_STATUSES.WITH_MY_EXPERTISE_COMPLETED]: {
    id: EXPERTISE_STATUSES.WITH_MY_EXPERTISE_COMPLETED,
    text: 'Экспертиза завершена',
    icon: null,
    attrs: {},
    searchKeys: {
      'search[with_my_expertise]': 1,
      'search[with_my_completed_expertise]': 1,
    },
  },
  [EXPERTISE_STATUSES.WITH_MY_EXPERTISE_NOT_COMPLETED]: {
    id: EXPERTISE_STATUSES.WITH_MY_EXPERTISE_NOT_COMPLETED,
    text: 'Экспертиза не завершена',
    icon: null,
    attrs: {},
    searchKeys: {
      'search[with_my_expertise]': 1,
      'search[with_my_completed_expertise]': 0,
    },
  },
};

export const EXPERTISE_STATUSES_LIST = Object.values(EXPERTISE_STATUSES_DATA)
  .sort((a, b) => a.id - b.id);

export default {
  EXPERTISE_STATUSES_DATA,

  EXPERTISE_STATUSES_LIST,
};
